<template>
  <div class="password">
    <van-form @submit="onSubmit">
      <van-field
        type="number"
        name="phone"
        v-model="phone"
        label="手机号"
        placeholder="请输入手机号"
      />
      <van-field
        type="password"
        v-model="password"
        name="password"
        label="新密码"
        placeholder="请输入新密码"
      />
      <van-field
        type="password"
        v-model="passwordAgain"
        label="确认密码"
        placeholder="请再次输入密码"
      />
      <van-field
        v-model="code"
        name="captcha"
        center
        clearable
        label="验证码"
        placeholder="请输入短信验证码"
      >
        <template #extra>
          <span class="code" @click="handleSendCode">
            {{ codeText }}
          </span>
        </template>
      </van-field>
      <div class="submit">
        <van-button type="primary">提交</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { captcha, setPassword } from "@/api/user";

export default {
  data() {
    return {
      phone: "",
      password: "",
      code: "",
      codeText: "获取验证码",
      sendCodeStatus: true,
      passwordAgain: ""
    };
  },
  methods: {
    // 提交
    onSubmit(values) {
      if (!this.phone) {
        this.$toast("请输入手机号");
        return false;
      }
      if (!this.password) {
        this.$toast("请输入密码");
        return false;
      }
      if (this.passwordAgain !== this.password) {
        this.$toast("密码不一致");
        return false;
      }
      if (!this.code) {
        this.$toast("请输入验证码");
        return false;
      }
      setPassword(values).then(res => {
        if (res.code === 0) {
          this.$router.push({
            name: "login",
            params: {
              openid: this.$route.params.openid,
              redirect: "/"
            }
          });
        }
      });
    },
    // 发送验证码
    handleSendCode() {
      if (!this.phone) {
        this.$toast("手机号不能为空");
        return false;
      }
      if (!/^1[3|4|5|7|8]\d{9}$/.test(this.phone)) {
        this.$toast("手机号格式不正确");
        return false;
      }
      if (this.sendCodeStatus) {
        let second = 60;
        let that = this;
        that.codeText = second + "s后获取";
        let timer_interval = setInterval(function() {
          if (second > 1) {
            second--;
            that.codeText = second + "s后获取";
          } else {
            clearInterval(timer_interval);
            that.codeText = "获取验证码";
            that.sendCodeStatus = true;
          }
        }, 1000);
        captcha(this.phone).then(res => {
          if (res.code === 0) {
            this.$toast("发送成功");
          }
        });
      }
      this.sendCodeStatus = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.password {
  .submit {
    margin: 20px;

    .van-button {
      width: 150px;
    }
  }
}
</style>
